export const tutorialSlides = [
  // {
  //   title: 'Earn with the Reddit Contributor Program',
  //   description: `
  //     <b>Earn</b>
  //     Fake internet points are finally worth something! Now redditors can earn real money for their contributions to the Reddit community. based on the karme and gold they've received.`,
  //   // screenshot: "reward-bg.jpg",
  //   screenshot: 'exp_1.jpeg',
  // },
  {
    title: 'Earn Points & Rewards',
    description: `
      <ul class="points">
        <li>Update Photos</li>
        <li>Add Promotions</li>
        <li>Update Prices</li>
        <li>Add or Improve Descriptions</li>
      </ul>
      `,
    descriptionOld: `
      <b>Update Photos</b>
      <p>Earn 1 point per approved photo (up to 4 points per listing)
      Snap and submit clear, relevant photos of the storefront, products, menus, or services.
      You’ll earn 1 point for each photo once approved.
      Maximum of 4 points per listing.</p>

      <p>Tip: Make sure your photos are clear and up-to-date for quicker approval!</p>
      

      <b>Add Promotions</b>

            <p>Earn 3 points when you're the first to submit a photo of a new, verifiable promotion.
      Capture promo signs, banners, or flyers with clear details.
      Add the promo under the relevant listing.</p>

      
      <p>      Note: Only the first approved submission will earn points. So be sure to add it before someone else does.
</p>



      <b>Update Prices</b>
            <p>Earn 1 point for each listing where you update the pricing details.
      Keep menus and service fees up to date.</p>

      
      <p>No approval needed – your point will be awarded instantly.</p>

      
      <p>      The more accurate the info, the better for the whole community!
</p>


      <b>Add or Improve Descriptions</b>
      

            <p>Earn 2–5 points based on the quality and relevance of your description.
      Write helpful, clear, and accurate descriptions about the business.
      Longer and more relatable descriptions may earn more points.
      Requires approval before points are added.</p>

      

            <p>Good descriptions help others know what to expect before visiting!</p>

      `,
    // screenshot: "reward-bg.jpg",
    screenshot: 'exp_1.jpeg',
  },
  {
    title: 'List My Service',
    description: `
                
        <p>Earn points for suggesting a business that’s not yet listed on Kachiing.
        Know a great place that’s missing from Kachiing? Recommend it!
        Submit key details like name, address, and type of service.</p>

        <p> If approved, you’ll receive points once the listing goes live.</p>

        <b>* Make sure it’s not already on Kachiing to qualify for points.</b>
      `,
    descriptionOld: `
                
        <p>Earn 15 points for suggesting a business that’s not yet listed on Kachiing.
        Know a great place that’s missing from Kachiing? Recommend it!
        Submit key details like name, address, and type of service.</p>

        <p> If approved, you’ll receive 15 points once the listing goes live.</p>

        <b>* Make sure it’s not already on Kachiing to qualify for points.</b>
      `,
    screenshot: 'new-sale.jpeg',
  },
  {
    title: 'Suggest Improvements',
    description: `
      <p>Earn 15–30 points for approved suggestions that help improve the platform.
      Got an idea to make Kachiing better? We’re listening.</p>
      
      <p>Submit your suggestion with a clear description and include a photo example if you can.</p>
      
      <p>If your suggestion is approved and selected, you’ll earn between 15 to 30 points depending on impact.</p>
      
      <b>The more thoughtful and actionable your suggestion, the more points you can earn!</b>
      
      
      `,
    screenshot: 'sugg_tut.jpeg',
    isCircle: false,
  },
  {
    title: 'Report Bugs',
    description: `
      <p>Earn 5–15 points if action is taken based on your report.</p>
      <p>Spotted something broken or incorrect on the site? Let us know!</p>
      
      <p>Submit the type of error or bug, a short description, and photo evidence if possible.
      If your report leads to a fix or improvement, you’ll earn 5 to 15 points, depending on the issue's severity and helpfulness of your report.</p>
      
      <p>Help us improve Kachiing for everyone, every detail counts!</p>
      `,
    screenshot: 'rep_tut.jpeg',
    isCircle: false,
  },
  {
    title: 'Share An Experience',
    description: `
      <p>Earn up to 8 points by contributing helpful reviews and photos.</p>
      <p>2 points for each approved review.</p>
      <b>+1 extra point when you include at least one relevant photo (total 3 points).
      +1 bonus point when your review receives its first 10 likes.
      +4 bonus points when your review receives its first 50 likes.</b>
     <p> Great reviews with useful details and photos not only help others, but reward you when your contribution gets noticed!</p>
    `,
    screenshot: 'review_image.png',
  },
  // {
  //   title: "Post a Moment Near You",
  //   description: "Capture moments around you and suggest improvements. Points are awarded for valuable contributions.",
  //   screenshot: "share_moment.png",
  // },
  // {
  //   title: "Claim Your Rewards",
  //   description: "Go to the Rewards page to claim gifts, discounts, or special perks. Enjoy the benefits of your contributions!",
  //   screenshot: "reward_1.png",
  // },
];

export const howSlides = [
  {
    title: 'How to Suggest Improvments',
    description: `
     <img src="../../../../../assets/images/how-to-contribute/how_to_suggest_improvments-2.png"/>
     <img src="../../../../../assets/images/how-to-contribute/how_to_suggest_improvments-3.png"/>
     <img src="../../../../../assets/images/how-to-contribute/how_to_suggest_improvments-4.png"/>
      <p>Suggestions help us improve the platform for everyone. If you have an idea that could make Kachiing better, we’d love to hear it.</p>
      <p>What makes suggestions on Kachiing unique is that we invite the community to
          like them before we consider implementation. This helps us focus on what matters
          most and decide which ideas to prioritise.
      </p>
      <p>Additionally, if your suggestion receives a lot of likes, you’ll also earn additional points!</p>
      <b>Where to find the Suggestion area.</b>
     <p>you can find the suggestion box in the contribute section on the home page.</p>
    `,
    screenshot: 'how_to_suggest_improvments-1.png',
  },
  {
    title: 'How to Make Reports',
    description: `
     <img src="../../../../../assets/images/how-to-contribute/how_to_suggest_improvments-2.png"/>
     <img src="../../../../../assets/images/how-to-contribute/how_to_make_reports-3.png"/>
     <img src="../../../../../assets/images/how-to-contribute/how_to_make_reports-4.png"/>

      <p>As Kachiing grows, we’re bound to face some issues during development and from
          user feedback. That’s why we appreciate your help in reporting anything we might
          have missed.
      </p>
      <p>Your reports help us identify problems faster and fix anything that could affect how
         Kachiing runs. You’ll also earn points for each valid report you submit.
      </p>
      <b>Where to find the Reporting area?</b>
     <p>you can find the Report box in the contribute section on the home page.</p>
    `,
    screenshot: 'how_to_suggest_improvments-1.png',
  },
  {
    title: 'How to Recommend a Business',
    description: `
      <p>
        Recommending a business on Kachiing is easy, whether you’re relaxing at home or
        out with friends and family. If you come across a business that you think others
        nearby would enjoy, simply send in a recommendation.
      </p>
      <b>Some examples of what you can recommend:</b>
      <ul>
        <li>A business you’ve personally tried and loved</li>
        <li>A place you’re visiting for the first time, if there’s something you like about it</li>
        <li> A home-based business or freelancer you feel deserves recognition</li>
        <li>A store running a promotion you think others would appreciate</li>
      </ul>
      <p>
        If you think it’s helpful, we’d love to hear about it.
      </p>
      <img src="../../../../../assets/images/how-to-contribute/how_to_recommend-2.png"/>
      <p>
        So now that you’ve found a recommendation, it’s time to list it and earn some points
        for your effort. We’ve made listing as simple as possible.
      </p>
      <p>Let’s go through a few key elements to get you started.</p>
      <img src="../../../../../assets/images/how-to-contribute/how_to_recommend-3.png"/>
      <img src="../../../../../assets/images/how-to-contribute/how_to_recommend-4.png"/>
      <p>Once you’ve filled in all the required details, just tap the Recommend button at the bottom and you’re done. You’ll receive your points shortly after submission.</p>
      <p>If your recommendation gets a lot of likes from the community, you’ll <b>earn additional coins</b>. So make sure to provide accurate information and take a few good shots of the store.</p>
    `,
    screenshot: 'how_to_recommend-1.png',
  },
  {
    title: 'How to Share Experances',
    description: `
      <p>
        Sharing an experience is simple and helps your community better understand what
        your visit was like. You can share your experience directly on the business’s listing
        and earn points for your contribution.
      </p>
      <p>
      Can’t find the business? Head over to “How to Recommend a Business” to learn how
      to suggest it on Kachiing and earn points as well.
      </p>

      <b>How to search</b>
      <p>To find a businesses listing on kachiing. Head over to the home page, and type the name of the business in the search bar.</p>
      <img src="../../../../../assets/images/how-to-contribute/how_to_share_experances-2.png"/>
      <p>Once you’ve found the business listing, tap on it and scroll to the bottom of the
          listing. You’ll see the Experiences section there. Make sure you’re logged in before
          submitting your experience.
      </p>
      <p>Here’s what it looks like:</p>
      <img src="../../../../../assets/images/how-to-contribute/how_to_share_experances-3.png"/>
      <img src="../../../../../assets/images/how-to-contribute/how_to_recommend-4.png"/>
      <p>Once you’ve finished sharing your experience, tap the Experience button at the bottom to submit. That’s it.</p>
      <p>You’ll receive your points shortly after submission.</p>
      <p>*Please note that any photos or text unrelated to the business may be flagged and removed.</p>
    `,
    screenshot: 'how_to_share_experances-1.png',
  },
  {
    title: 'How To Update Nearby',
    description: `
      <p>
        If you’ve just visited a business near you and have helpful updates to share, you can
        submit them directly on the business’s listing and earn points for your contribution.
      </p>
      <p>
        Can’t find the business? Head over to “How to Recommend a Business” to learn how
        to suggest it for Kachiing and earn points too.
      </p>
      <b>How to Find Businesses you can update?</b>
      <p>To find a updateable listings on kachiing. Head over to the <b>“Nearby”</b> on mobile and <b“My Nearby”></b> on PC to see listings in your area that you can update.</p>
      <img src="../../../../../assets/images/how-to-contribute/how_to_update_nearby-2.png"/>
      <img src="../../../../../assets/images/how-to-contribute/how_to_update_nearby-3.png"/>
      <p>Once you have found the businesses listing, click on the listing and look at the middle right area of the listing for the contribute icon with the coin</p>
      <p>This is what you will see</p>
      <img src="../../../../../assets/images/how-to-contribute/how_to_update_nearby-4.png"/>
      <img src="../../../../../assets/images/how-to-contribute/how_to_recommend-4.png"/>
      <p>Once you’ve updated all the required details, just tap the Submit button at the bottom and you’re done.</p>
      <p>You’ll receive your points shortly after submission.</p>
      <p>Keeping listings accurate and relevant helps everyone in the community and is a great way to earn points.</p>
    `,
    screenshot: 'how_to_share_experances-1.png',
  },
  {
    title: 'Rewards',
    description: `
     <img src="../../../../../assets/images/how-to-contribute/how_rewards-2.png"/>
     <img src="../../../../../assets/images/how-to-contribute/how_rewards-3.png"/>
     <img src="../../../../../assets/images/how-to-contribute/how_rewards-4.png"/>
    `,
    screenshot: 'how_rewards-1.png',
  },
];

export const RECOMMEND_REWARD_KEY = 'RECOMMEND_REWARD';
export const SUGGESTIONS_REWARD_KEY = 'SUGGESTIONS_REWARD';
export const REPORTS_REWARD_KEY = 'REPORTS_REWARD';
export const PRODUCTS_POST_REWARD_KEY = 'PRODUCTS_POST_REWARD';
export const ASK_POST_REWARD_KEY = 'ASK_POST_REWARD';
export const REVIEW_REWARD_KEY = 'REVIEW_REWARD';
export const SUGGEST_REWARD_KEY = 'SUGGEST_REWARD';
export const MOMENTS_REWARD_KEY = 'MOMENTS_REWARD';
export const REWARD_PER_20_LIKES_RECOMMENDED_PRODOCUT_KEY =
  'REWARD_PER_20_LIKES_RECOMMENDED_PRODOCUT';
export const REWARD_PER_20_LIKES_DISSCUSS_KEY =
  'REWARD_PER_20_LIKES_DISSCUSS';
export const REWARD_PER_20_LIKES_XP_KEY = 'REWARD_PER_20_LIKES_XP';
export const POINT_OF_CONTACT_EXTRA_REWARD_KEY = 'POINT_OF_CONTACT_EXTRA_REWARD'
export const RECOMMENDATION_IMAGE_EXTRA_REWARD_KEY = 'RECOMMENDATION_IMAGE_EXTRA_REWARD'
export const POLL_REWARD_KEY = 'POLL_REWARD'
export const LIMIT_POLL_REWARD_KEY = 'LIMIT_POLL_REWARD'